export default __webpack_public_path__ + "static/review_image-a8de87b79eb1bbcec9e9df9301576d6e.png";